import { jwtDecode } from 'jwt-decode';
import { AttendantData } from '@/zustand/interfaces/attendant-data';

export const getAttendantUser = (jwt: string): AttendantData => {
  const data = jwtDecode<AttendantData>(jwt);
  return data;
};
